'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPersonPin = function MdPersonPin(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 26.6v-1.4c0-3.4-6.6-5.2-10-5.2s-10 1.8-10 5.2v1.4h20z m-10-17.8c-2.5 0-4.5 2.1-4.5 4.6s2 4.4 4.5 4.4 4.5-1.9 4.5-4.4-2-4.6-4.5-4.6z m11.6-5.4c1.8 0 3.4 1.4 3.4 3.2v23.4c0 1.8-1.6 3.4-3.4 3.4h-6.6l-5 5-5-5h-6.6c-1.9 0-3.4-1.6-3.4-3.4v-23.4c0-1.8 1.5-3.2 3.4-3.2h23.2z' })
        )
    );
};

exports.default = MdPersonPin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/person-pin.js
// module id = 1039
// module chunks = 0